// components/structure/GeneralContent.tsx
'use client';
import { LayoutContext } from '@/context/LayoutContext';
import { NextIntlClientProvider } from 'next-intl';
import { ReactNode, useContext } from 'react';

type GeneralContentProps = {
  locale: string;
  messages: any;
  children: ReactNode;
  page?: boolean;
  className?: string;
  dir?: string;
};

export default function GeneralContent({
  locale,
  messages = null,
  children,
  page = true,
  className = '',
  dir,
}: GeneralContentProps) {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  // console.log('GeneralContent messages:', JSON.stringify(messages, null, 2)); // Debug
  return (
    <NextIntlClientProvider messages={messages} locale={locale} timeZone={timeZone}>
      <div className={`wrapperstyle ${dir} ${className}`}>{children}</div>
    </NextIntlClientProvider>
  );
}
